// VisionSystem.jsx
import React from "react";


import { Link } from "react-router-dom";
import "./SystemSubsystem.css";

// ✅ Import images with proper names
import abcr from "../Assessts/VisionSystems/1abcr.png";
import laserinspectionrobot from "../Assessts/VisionSystems/2laserinspectionrobot.png";
import tetheredronesystem from "../Assessts/VisionSystems/3tetheredronesystem.png";
import IRGimble from "../Assessts/VisionSystems/4IRgimbles.png";
import gimblebased from "../Assessts/VisionSystems/5gimblebased.png";
import ShipBorneDualSensor from "../Assessts/VisionSystems/6ShipBorneDualSensor.png";
import compactairborne from "../Assessts/VisionSystems/7compactairborne.png";
import laser_range_bodycamera from "../Assessts/VisionSystems/8laser_range_bodycamera.png";
import trail_camera from "../Assessts/VisionSystems/9trail_camera.png";
import rugged_camera from "../Assessts/VisionSystems/10rugged_camera.png";
import facerecognization_camera from "../Assessts/VisionSystems/11facerecognization_camera.png";
import RuggedCamera from "../Assessts/VisionSystems/12RuggedCamera.png";
import thermail_imager from "../Assessts/VisionSystems/13thermail_imager.png";
import monocular from "../Assessts/VisionSystems/14monocular.png";
import holographic_sight from "../Assessts/VisionSystems/15holographic sight.png";
import underwater_camerasystem from "../Assessts/VisionSystems/16underwater_camerasystem.png";
import EO from "../Assessts/VisionSystems/17EO.png";
import Buoy from "../Assessts/VisionSystems/18Buoy.png";
import aicompute from "../Assessts/VisionSystems/19aicompute.png";
import ndsdu from "../Assessts/VisionSystems/20NDSDU.png";

// ✅ Products array with proper titles and 4-line descriptions
const products = [
  {
    id: 1,
    title: "ABCR CAMERA",
    img: abcr,
    desc: "Advanced vision system providing clear optical performance. \nDesigned for aerospace and defense-grade applications. \nDelivers reliable imaging across diverse conditions. \nEngineered for precision surveillance operations. \nEquipped with adaptive optics for enhanced clarity. \nIntegrates seamlessly with UAVs, vehicles, and ground platforms. \nTested for ruggedness under extreme mission conditions.",
  },
  {
    id: 2,
    title: "LASER INSPECTION ROBOT",
    img: laserinspectionrobot,
    desc: "Robotic laser system for precise inspection tasks. \nEnables automated defect detection and 3D mapping. \nSuitable for aerospace, railways, and defense sectors. \nOffers accuracy and reliability in field deployment. \nCapable of handling complex structural evaluations. \nReduces human error with AI-driven analysis. \nEnsures compliance with high safety and quality standards.",
  },
  {
    id: 3,
    title: "TETHERED DRONE SYSTEM",
    img: tetheredronesystem,
    desc: "Persistent aerial platform with continuous power. \nSupports surveillance and communication relays. \nIdeal for border monitoring and tactical missions. \nEnsures extended endurance with stable connectivity. \nDesigned for uninterrupted intelligence gathering. \nProvides real-time video and data transmission. \nOperates securely in restricted airspace environments.",
  },
  {
    id: 4,
    title: "IR GIMBAL CAMERA",
    img: IRGimble,
    desc: "Infrared gimbal providing stabilized thermal imagery. \nEnables day-night target tracking and reconnaissance. \nOptimized for UAVs, naval, and land-based platforms. \nBuilt for rugged and dynamic mission environments. \nEquipped with precision stabilization for clear imaging. \nSupports long-range thermal detection capabilities. \nEngineered for persistent surveillance under all weather conditions.",
  },
  {
    id: 5,
    title: "GIMBAL BASED SYSTEM",
    img: gimblebased,
    desc: "Multi-axis gimbal ensuring precise stabilization. \nSupports both EO and IR sensor payloads. \nEnhances clarity in high-vibration environments. \nCritical for defense surveillance and tracking systems. \nCustomizable for various platform integrations. \nEnsures real-time smooth video capture in motion. \nField-proven for durability in complex operations.",
  },
  {
    id: 6,
    title: "SHIP BORNE DUAL SENSOR",
    img: ShipBorneDualSensor,
    desc: "Dual-sensor vision system for maritime security. \nProvides long-range EO/IR surveillance coverage. \nRuggedized for naval and coastal defense missions. \nEnsures reliable performance under harsh sea conditions. \nDesigned for continuous monitoring and early threat detection. \nIntegrates with ship combat management systems. \nDelivers superior situational awareness for naval operations.",
  },
  {
    id: 7,
    title: "COMPACT AIRBORNE SYSTEM",
    img: compactairborne,
    desc: "Lightweight airborne vision payload for UAVs. \nDelivers high-resolution EO/IR imaging. \nDesigned for tactical reconnaissance missions. \nCompact, efficient, and mission-ready design. \nEngineered for endurance with minimal payload weight. \nProvides enhanced aerial situational awareness. \nIdeal for both defense and homeland security tasks.",
  },
  {
    id: 8,
    title: "LASER RANGE BODY CAMERA",
    img: laser_range_bodycamera,
    desc: "Wearable body camera with integrated laser rangefinder. \nCaptures clear evidence in law enforcement missions. \nProvides distance measurement and situational awareness. \nBuilt for rugged, on-field defense applications. \nOffers real-time video transmission for command centers. \nEnsures officer safety with precise range data. \nLightweight, ergonomic, and mission-adaptable design.",
  },
  {
    id: 9,
    title: "TRAIL CAMERA",
    img: trail_camera,
    desc: "Surveillance camera for remote area monitoring. \nIdeal for perimeter security and wildlife tracking. \nDelivers motion-triggered image and video capture. \nOperates efficiently in low-light environments. \nProvides long battery life for extended deployments. \nRugged build ensures performance in outdoor terrains. \nSupports covert monitoring for tactical operations.",
  },
  {
    id: 10,
    title: "RUGGED CAMERA",
    img: rugged_camera,
    desc: "Durable camera built for extreme environments. \nShockproof, waterproof, and dust-resistant housing. \nSuitable for military, aerospace, and industrial use. \nEnsures reliable imaging under harsh conditions. \nDesigned to function in extreme temperature ranges. \nCompact build with high-definition imaging. \nTrusted for long-term field deployment missions.",
  },
  {
    id: 11,
    title: "FACE RECOGNITION CAMERA",
    img: facerecognization_camera,
    desc: "Smart camera with AI-powered face recognition. \nSupports real-time identification and access control. \nIdeal for security, defense, and smart city projects. \nOptimized for accuracy and speed in deployment. \nIntegrates seamlessly with existing surveillance systems. \nOffers advanced analytics for threat detection. \nCapable of handling high-density crowds with precision.",
  },
  {
    id: 12,
    title: "RUGGEDIZED CAMERA SYSTEM",
    img: RuggedCamera,
    desc: "Enhanced ruggedized camera for mission-critical tasks. \nWithstands shock, vibration, and temperature extremes. \nEngineered for defense and aerospace applications. \nDelivers uninterrupted imaging in field conditions. \nCertified to meet military-grade standards. \nEquipped with adaptive optics for clarity in motion. \nIdeal for continuous operation in harsh terrains.",
  },
  {
    id: 13,
    title: "THERMAL IMAGER",
    img: thermail_imager,
    desc: "High-resolution thermal imaging device. \nDetects heat signatures in complete darkness. \nEssential for surveillance, SAR, and defense ops. \nProvides superior clarity in varied environments. \nLightweight, portable, and easy to deploy. \nOptimized for both handheld and mounted use. \nDelivers dependable results for critical missions.",
  },
  {
    id: 14,
    title: "MONOCULAR CAMERA",
    img: monocular,
    desc: "Compact monocular device for tactical vision. \nLightweight and portable for field operations. \nSupports EO/IR capability in handheld format. \nTrusted by defense and security professionals. \nDesigned for rapid target detection and tracking. \nOperates effectively in low-visibility conditions. \nEngineered for durability in mission environments.",
  },
  {
    id: 15,
    title: "HOLOGRAPHIC SIGHT",
    img: holographic_sight,
    desc: "Advanced holographic targeting sight system. \nProvides rapid and precise target acquisition. \nDesigned for rifles and tactical defense weapons. \nEnsures accuracy in high-pressure missions. \nEquipped with wide field-of-view for faster response. \nEngineered to withstand recoil and rough handling. \nTrusted by defense forces for precision shooting.",
  },
  {
    id: 16,
    title: "UNDERWATER CAMERA SYSTEM",
    img: underwater_camerasystem,
    desc: "Specialized camera for underwater monitoring. \nDelivers high-quality imaging in marine conditions. \nSupports defense, exploration, and rescue missions. \nRugged build ensures long-term underwater operation. \nOptimized for deep-sea surveillance and inspection. \nEquipped with waterproof lighting systems. \nDesigned for continuous deployment in sub-sea missions.",
  },
  {
    id: 17,
    title: "EO SENSOR MODULE",
    img: EO,
    desc: "Electro-optical module for advanced vision tasks. \nIntegrates with UAVs, naval, and ground systems. \nProvides high-resolution real-time surveillance. \nBuilt for versatility in multi-domain operations. \nCompact, modular, and scalable for platforms. \nEngineered for precision in tactical environments. \nDelivers dependable situational awareness solutions.",
  },
  {
    id: 18,
    title: "BUOY VISION SYSTEM",
    img: Buoy,
    desc: "Autonomous buoy-based surveillance system. \nEquipped with EO/IR and communication modules. \nSupports maritime domain awareness missions. \nOperates continuously in challenging sea conditions. \nDesigned for long-duration autonomous operation. \nIntegrates with coastal security networks. \nProvides real-time alerts for maritime threats.",
  },
  {
    id: 19,
    title: "AI COMPUTE MODULE",
    img: aicompute,
    desc: "High-performance AI computing vision module. \nAccelerates real-time object detection and tracking. \nOptimized for deep learning on edge devices. \nEssential for defense, UAVs, and robotics systems. \nCompact design with high compute efficiency. \nSupports multiple AI frameworks and models. \nDelivers intelligence directly at the edge without latency.",
  },
  {
    id: 20,
    title: "Discrete Signal Distribution UNIT-NDSDU",
    img: ndsdu,
    desc: "Advanced unit for reliable discrete signal distribution. \nEnsures secure and noise-immune routing across platforms. \nDesigned for aerospace, defense, and railway systems. \nSupports real-time monitoring and fault isolation. \nCompact and rugged for harsh environments. \nComplies with safety and industry standards. \nCustomizable for platform-specific integration.",

  },
];



export default function SystemSubsystem() {
  return (
    // <div style={{ background: "linear-gradient(135deg, rgba(28, 29, 31, 0.95), rgba(255, 255, 255, 0.9))" }}>
    <div style={{ background: "white" }}>
      <h2
        style={{
          fontWeight: 600,
          textAlign: "center",
          marginBottom: "50px",
          // marginTop: "50px",
          paddingTop:"50px",
          // color:"rgba(14, 14, 69, 0.88)"
          color:"#074f86ff"
        }}
      >
        {/* TRENDING <span>↗</span>
         */}
         RUGGED VISION SYSTEMS
      </h2>
      <div className="system-grid">
        {products.map((item) => (
          <div className="system-card" key={item.id}>
            <img src={item.img} alt={item.title} style={{ height: "250px", objectFit: "contain" }}/>
            <div className="card-title">{item.title}</div>

            {/* description overlay appears only on hover */}
            <div className="hover-desc">
              <p>{item.desc}</p>
              <Link to={`/VisionSystemDetails/${item.id}`} className="view-product-btn">
                View Product
              </Link>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export { products }; // export products so ProductDetails can use
